<template lang="pug">
.full-width
  event-sections-container
  user-requirements-dialog(
    v-model="isUserRequirementsDialogOpen"
    :fields="fields"
  )
    template(#text)
      p Заполните данные профиля, чтобы мы могли рекомендовать вам мероприятия рядом
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import EventSectionsContainer from '@/modules/Events/components/event-view/EventSectionContainer.vue';
import UserRequirementsDialog from '@/components/dialogs/UserRequirementsDialog.vue';
import { VISITED_EVENTS_TO_FILL_PROFILE } from '@/modules/Events/constants';

export default {
  name: 'EventLandingView',
  components: {
    EventSectionsContainer,
    UserRequirementsDialog,
  },
  data() {
    return {
      isUserRequirementsDialogOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      visitedEvents: 'auth/getVisitedEvents',
    }),
    fields() {
      return {
        region: { required: true },
        municipality: { required: true },
        first_name: { required: false },
        last_name: { required: false },
        birthday_at: { required: false },
        snils: { required: false },
      };
    },
  },
  watch: {
    visitedEvents(value) {
      if (value >= VISITED_EVENTS_TO_FILL_PROFILE && this.$user.isAuthenticated && this.$user.isMember) {
        if (!this.$user?.profile?.region || !this.$user?.profile?.municipality) {
          // ! @FIX creation DialogsContainer happens earlier than watch
          setTimeout(() => {
            this.isUserRequirementsDialogOpen = true;
          }, 200);
        }

        this.resetVisitedEvents();
      }
    },
  },
  mounted() {
    this.visitEvent();
  },
  methods: {
    ...mapActions({
      visitEvent: 'auth/visitEvent',
      resetVisitedEvents: 'auth/resetVisitedEvents',
    }),
  },
};
</script>
